import { render, staticRenderFns } from "./app-switcher.vue?vue&type=template&id=9972349e&"
import script from "./app-switcher.vue?vue&type=script&lang=js&"
export * from "./app-switcher.vue?vue&type=script&lang=js&"
import style0 from "./app-switcher.vue?vue&type=style&index=0&id=9972349e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports